module.exports = __webpack_public_path__ + "img/aboutustime.89f7b5a0.png";